module.exports = __webpack_public_path__ + "static/media/Icons-4.b148ba9b.svg";